import React, { Component } from 'react';
class AutoTransferCh extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="mgt-30 faq-container">
            <div className="text-center block-title">
              <h2 className="common-title">TRIAM Auto Transfer</h2>
              <span>version: 1.0.1</span>
            </div>
            <div className="content">
              <section className="opening">
                <div className="intro">
                  什么是Auto Transfer的功能？当您的电子钱包超过所设置的代币数量时，多余的代币将自动转入另一个电子钱包的一种功能。
                  例如 在接收顾客支付代币的电子钱包中设置此功能，既可以防止电子钱包中的余额过多，并且可以提高电子钱包的高安全性。
                </div>
                <div className="example">
                  <p>例</p>
                  <ul className="list">
                    <li>
                      <div className="text">
                        <span>① 接收顾客支付代币的电子钱包」进行Auto Transfer的功能设置</span>
                        <span>设置的代币：RIA</span>
                        <span>设置代币的数量：500,000 RIA</span>
                        <span>转送的电子钱包：「顾客支付管理电子钱包」</span>
                      </div>
                    </li>
                    <li>
                      <div className="text">
                        <span>② 顾客对「接收顾客支付代币的电子钱包」进行发送代币。当（接收顾客支付代币的电子钱包）内的代币数量超过了您所设置代币数量的时候 多余的代币数量将自动转移至（顾客支付管理电子钱包）中。</span>
                      </div>
                    </li>
                  </ul>
                  <div class="img">
                    <img src="/images/auto-transfer-des-ch.png" alt="Auto Transfer Des" />
                  </div>
                </div>
              </section>
              <hr />
              <section className="guide">
                <h3><b>Auto Transfer功能的设置顺序</b></h3>
                <ul className="step-guide decimal">
                  <li>登录账号 从菜单中的「Auto Transfer」页面开始设置</li>
                  <li>
                    <div className="text">
                      <span>点击［Setup Auto Transfer］按钮</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s1.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>在名称字段中输入设置Auto Transfer的内容。</span>
                      <span>请选择需要设置Auto Transfer功能的Source Wallet。</span>
                      <span>请在电子钱包中输入Amount持有余额的最大量。</span>
                      <span>(例) 如果将Amount设置为100000时 该电子钱包超过持有代币100000时 Auto Transfer的功能将自动开启 自动的将超出的数量转送至所指定的电子钱包中。</span>
                      <span>请在Asset选择代币的种类。</span>
                      <span>请点击［NEXT］按钮。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s2.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>下一步设置 启用Auto Transfer前先设置转送代币用的（Destination Wallet）电子钱包。</span>
                      <span>如果需要同一个账号设置电子钱包，请在「Select destination from your wallets」中选择。</span>
                      <span>如果在不同账号内设置电子钱包的 直接在「Enter the destination」的字段中直接输入电子钱包地址。</span>
                      <span>请确认输入的电子钱包地址后点击［NEXT］按钮。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s3.png" alt="Auto Transfer S3" />
                    </div>
                    <div className="text highlight">
                      <span>注意！</span>
                      <span>Destination Wallet 接收代币时请设置一个不需要Tag的电子钱包。例如 如果需要输入Tag交易所的电子钱包 虽然Auto Transfer也会自动执行转送，请注意 会出现接收方接收时显示一笔未知存款的可能性。</span>
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>在下一页面可以确认所设置的Auto Transfer流程图。</span>
                      <span>请按［NEXT］按钮确认。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s4.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>将显示最终确认画面 请确认并点击［CONFIRM］按钮。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s5.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>请输入OP密码和谷歌双重身份验证</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s6.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>Auto Transfer的设置资料可在各电子钱包中确认。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s7.png" alt="Auto Transfer S1" />
                    </div>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AutoTransferCh;



// WEBPACK FOOTER //
// ./src/containers/auto-transfer-ch.jsx